import * as React from "react";
import * as PropTypes from "prop-types";
import ReCaptcha from "react-google-recaptcha";
import {Card, CardBody, CardHeader} from "reactstrap";
import {reduxForm} from "redux-form";
const {Form, FormActions, FormBody} = form;
import {Loader, ff, utils, form} from "@mc/mc-legacy";
import './PasswordResetForm.scss';
import {withTranslation} from "react-i18next";

function PasswordResetForm(props) {
    const {handleSubmit, reCaptchaSiteKey, t} = props;
    return <Form horizontal onSubmit={handleSubmit} className="password-reset-form">
        <FormBody>
            <Card>
                <CardHeader>Obnova hesla</CardHeader>
                <CardBody>
                    <ff.String className="login-name" name="loginName" label={t('labels.username')} />
                    {reCaptchaSiteKey ? <ff.Base componentClass={ReCaptcha} name="captcha" label={t('validation.captcha')} className="mt-2" sitekey={reCaptchaSiteKey} /> : <Loader />}
                </CardBody>
            </Card>
        </FormBody>
        <FormActions submitButton={t('buttons.refresh_password')} resetButton={true} />
    </Form>
}

PasswordResetForm.propTypes = {
    reCaptchaSiteKey: PropTypes.string.isRequired
};

export default withTranslation()(reduxForm({
    form: "PasswordResetForm",
    validate: (data) => utils.requireFields(["loginName", "captcha"])(data)
})(PasswordResetForm));

